import spriteUrl from "/images/sprite.png";

const sprite = new Image();
sprite.src = spriteUrl;

// id: [x, y, width, height]
const NPCsSprites = {
    //town npcs
    17: [12, 0, 15, 14],
    18: [27, 0, 14, 11],
    19: [63, 0, 11, 11],
    20: [50, 0, 13, 11],
    22: [0, 0, 12, 11],
    37: [64, 21, 13, 13],
    38: [41, 0, 9, 13],
    54: [74, 0, 14, 13],
    107: [99, 0, 11, 9],
    108: [110, 0, 17, 21],
    124: [88, 0, 11, 10],
    142: [127, 0, 12, 17],
    160: [139, 0, 16, 15],
    178: [155, 0, 11, 12],
    207: [166, 0, 11, 11],
    208: [177, 0, 15, 10],
    209: [192, 0, 11, 12],
    227: [203, 0, 10, 10],
    228: [213, 0, 16, 12],
    229: [229, 0, 13, 17],
    353: [0, 21, 15, 15],
    368: [167, 21, 15, 16],
    369: [31, 21, 12, 12],
    441: [42, 21, 12, 14],
    550: [54, 21, 10, 10],
    //1.4
    588: [143, 21, 10, 10],
    633: [129, 21, 14, 14],
    637: [
        [182, 21, 8, 9],
        [190, 21, 8, 9],
        [198, 21, 8, 9],
        [206, 21, 8, 9],
        [214, 21, 9, 10],
        [223, 21, 8, 9]
    ],
    638: [
        [182, 31, 11, 9],
        [193, 31, 11, 10],
        [204, 31, 11, 9],
        [215, 31, 11, 11],
        [226, 31, 11, 9],
        [237, 31, 11, 11]
    ],
    656: [
        [182, 42, 7, 10],
        [189, 42, 8, 12],
        [197, 42, 7, 10],
        [204, 42, 7, 10],
        [211, 42, 8, 7],
        [219, 42, 7, 10]
    ],
    663: [153, 21, 14, 16],

    //pillars
    422: [90, 21, 13, 15],
    493: [116, 21, 13, 15],
    507: [103, 21, 13, 15],
    517: [77, 21, 13, 15],

    unknown: [22, 37, 8, 12] //30
};

const WorldPointsSprites = {
    dungeon: [0, 37, 11, 11],
    spawn: [11, 37, 11, 12]
};

export default sprite;
export {
    spriteUrl,
    NPCsSprites,
    WorldPointsSprites
}